import { SKTPanel, SKTPanelBody } from "../components/SKTPanel";
import { SKTForm } from "../components/SKTForm";
import { SKTInfo } from "../components/SKTInfo";
import { SKTRadioButton, SKTRadioOption } from "../components/SKTRadioButton";
import { SKTAddressField } from "../components/SKTAddressField";
import { useData } from "../hooks/Data";
import {
  SKTFileField,
  SKTTextArea,
  SKTTextField,
} from "../components/SKTTextField";
import { SKTAction } from "../components/SKTAction";
import { apiPOST } from "../hooks/APIHook";
import { useRef, useState } from "react";
import { API_ENDPOINTS } from "../config";
import qs from "qs";
import { css } from "../components/SKT";
import { SKTToggle } from "../components/SKTToggle";

export const DamageClaim = ({ skt }) => {
  const data = useData({});
  const [state, setState] = useState("view");
  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();

  const doSendClaim = () => {
    console.log(data.values);
    apiPOST(API_ENDPOINTS.damageClaim, qs.stringify(data.values))
      .then((result) => {
        if (result.data.status === "ok") setState("done");
        else setState("error");
        executeScroll();
      })
      .catch((reason) => {
        setState("error");
        executeScroll();
      });
  };

  if (state === "done") {
    return (
      <SKTPanel>
        <SKTPanelBody>
          <SKTForm>
            <span ref={myRef}></span>
            <SKTInfo>
              <h4>Korvaushakemus on lähetetty!</h4>
            </SKTInfo>
          </SKTForm>
        </SKTPanelBody>
      </SKTPanel>
    );
  }

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <span ref={myRef}></span>
          <SKTInfo>
            <SKTToggle when={state === "error"}>
              <p className={css("error")}>
                Virhe korvausvaatimuksen tallentamisessa!
              </p>
            </SKTToggle>
            <h4>Korvauksen hakijan tiedot</h4>
          </SKTInfo>

          <SKTRadioButton
            id="acct_type"
            data={data}
            singleValue={true}
            label="Olen"
          >
            <SKTRadioOption value="private" label="Yksityishenkilö" />
            <SKTRadioOption value="corporate" label="Yritysasiakas" />
          </SKTRadioButton>

          <SKTAddressField
            data={data}
            prefix="iS"
            corporate={data.get("acct_type") === "corporate"}
          />
          <SKTInfo>
            <h4>Tiedot vahingosta</h4>
          </SKTInfo>

          <SKTTextField
            id="iPNumber"
            data={data}
            label="Tilausnumero"
            placeholder="Täytä tähän kuljetustilauksen numero, esim. 100234"
          />

          <SKTRadioButton
            id="iPType"
            data={data}
            singleValue={true}
            label="Vahingon syy"
          >
            <SKTRadioOption value="Vahingoittuminen" label="Vahingoittuminen" />
            <SKTRadioOption value="Katoaminen" label="Katoaminen" />
            <SKTRadioOption value="Viivästyminen" label="Viivästyminen" />
            <SKTRadioOption value="Muu vahinko" label="Muu vahinko" />
          </SKTRadioButton>

          <SKTTextField
            id="iPServices"
            data={data}
            label="Lisäpalvelut, mitkä?"
          />

          <SKTTextArea id="iPText" data={data} label="Selostus vahingosta" />
          <SKTTextArea
            id="iPPackageDescription"
            data={data}
            label="Miten lähetys oli pakattu?"
          />

          <SKTInfo>
            <h4>Korvaushakemus eriteltynä</h4>
          </SKTInfo>

          <SKTTextField
            id="iXPostal"
            data={data}
            label="Posti- tai kuljetusmaksu"
            placeholder="erittely ja arvo euroina"
          />
          <SKTTextField
            id="iXParcel"
            data={data}
            label="Tavaran arvo"
            placeholder="erittely ja arvo euroina"
          />
          <SKTTextField
            id="iXCat1"
            data={data}
            label="Muu kulu"
            placeholder="Selvennä muu kulu"
          />
          <SKTTextField
            id="iXVal1"
            data={data}
            label=""
            placeholder="erittely ja arvo euroina"
          />
          <SKTTextField
            id="iXCat2"
            data={data}
            label="Muu kulu"
            placeholder="Selvennä muu kulu"
          />
          <SKTTextField
            id="iXVal2"
            data={data}
            label=""
            placeholder="erittely ja arvo euroina"
          />
          <SKTTextField
            id="iXTotal"
            data={data}
            label="Korvausvaatimus yhteensä"
            placeholder="arvo euroina"
          />
          <SKTTextField
            id="iPAccountNumber"
            data={data}
            label="Tilinumero korvauksen maksamista varten"
          />

          <SKTFileField
            id="iXFile"
            data={data}
            label="Liitteeksi kuitti tai lasku josta ilmenee tavaran arvo tai korjauskustannukset"
          />

          <SKTAction
            actionLabel="Lähetä korvausvaatimus"
            onClick={() => doSendClaim()}
            active={true}
            type="btn-success"
          ></SKTAction>
        </SKTForm>
      </SKTPanelBody>
    </SKTPanel>
  );
};
